/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Draught_DescriptionInputs */



/**
* | output |
* | --- |
* | "Independent draught surveys to determine the weight of bulk cargo loaded or discharged." |
*
* @param {Service_Draught_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_draught_description = /** @type {((inputs?: Service_Draught_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Draught_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("通过独立的水尺计重确定装卸散货的重量。")
	return /** @type {LocalizedString} */ ("Independent draught surveys to determine the weight of bulk cargo loaded or discharged.")
});